import addressesService from "presentation/services/addresses";
import React from "react";
import { Col, Container, Form, Row, Button, InputGroup } from "react-bootstrap";

import PageLoadingIndicator from "presentation/components/page-loading-indicator";
import PageAlert from "presentation/components/page-alert";

class AddressTabResponsibleForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            actionLoading: false,
            error: false,
            message: '',
        };

    }
    loadExternalZipCode = async () => {

        this.setState({ actionLoading: true, error: false });

        let { addressForm: form, component } = this.props;

        const zipCode = form?.zipCode || undefined;

        if (!zipCode) {
            this.setState({ actionLoading: false, error: true, message: "Por favor, preencha um cep..." });
        } else {
            try {
                const response = await addressesService.searchExternal(zipCode);
                if (response.error == true) {
                    this.setState({
                        actionLoading: false,
                        error: true,
                        message: response.message
                    });
                } else {
                    const data = response[0];
                    let addressData = {
                        addressField: data?.fullAddress || "",
                        district: data?.districtName || "",
                        city: data?.cityName || "",
                        state: data?.stateShortName || "",
                        country: "Brasil"
                    };
                    component.setState({ addressForm: { ...form, ...addressData } });

                    this.setState({
                        actionLoading: false,
                        error: false,
                        message: ''
                    });
                }
            } catch (err) {
                this.setState({
                    actionLoading: false,
                    error: true,
                    message: err.message
                });
            }
        }
    };

    render() {
        let { addressForm: form, form: mainForm, handleChange, component } = this.props;
        const { actionLoading, message, error } = this.state;
        const { loadExternalZipCode } = this;

        const disableAddressInput = mainForm?.sameAddressOfStudent == true ? true : false;

        return (
            <>
                {actionLoading === true && <PageLoadingIndicator loadingText="Por favor, aguarde..." />}
                {actionLoading === false && error === true && <PageAlert className="m-b-20" message={"Erro"} description={message} type="danger" />}
                {actionLoading === false && (
                    <Container>
                        <Row>
                            <Col>
                                <h4>Informações do endereço</h4>
                            </Col>
                            <Col>
                                <Form.Check
                                    inline
                                    type="checkbox"
                                    id="sameAddressOfStudent"
                                    name="sameAddressOfStudent"
                                    label={"Mesmo endereço do(a) aluno(a)"}
                                    checked={mainForm?.sameAddressOfStudent}
                                    onChange={(e) => handleChange(e, component)}
                                    className="float-end"
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={4}>
                                <div className="form mt-2">
                                    <Form.Label htmlFor="zipCode">CEP / Código postal</Form.Label>
                                    <InputGroup>
                                        <Form.Control
                                            type="text"
                                            id="zipCode"
                                            name="zipCode"
                                            defaultValue={form?.zipCode}
                                            onChange={(e) => handleChange(e, component, 'addressForm')}
                                            aria-describedby="zipCodeHelpBlock"
                                            disabled={disableAddressInput}
                                        />
                                        <Button disabled={disableAddressInput} variant="success" className="m-l-1" onClick={async () => await loadExternalZipCode()} >Buscar</Button>
                                    </InputGroup>

                                    <Form.Text id="zipCodeHelpBlock" muted>
                                        Informe o código postal
                                    </Form.Text>
                                </div>

                            </Col>
                            <Col lg={12}></Col>
                            <Col lg={6}>
                                <div className="form mt-2">
                                    <Form.Label htmlFor="addressField">Logradouro</Form.Label>
                                    <Form.Control
                                        type="text"
                                        id="addressField"
                                        name="addressField"
                                        defaultValue={form?.addressField}
                                        onChange={(e) => handleChange(e, component, 'addressForm')}
                                        aria-describedby="addressFieldHelpBlock"
                                        disabled={disableAddressInput}
                                    />
                                    <Form.Text id="addressFieldHelpBlock" muted>
                                        Informe o logradouro
                                    </Form.Text>
                                </div>
                            </Col>
                            <Col lg={2}>
                                <div className="form mt-2">
                                    <Form.Label htmlFor="number">N.º</Form.Label>
                                    <Form.Control
                                        type="text"
                                        id="number"
                                        name="number"
                                        defaultValue={form?.number}
                                        onChange={(e) => handleChange(e, component, 'addressForm')}
                                        aria-describedby="numberHelpBlock"
                                        disabled={disableAddressInput}
                                    />
                                    <Form.Text id="numberHelpBlock" muted>
                                        Informe o número
                                    </Form.Text>
                                </div>
                            </Col>
                            <Col lg={4}>
                                <div className="form mt-2">
                                    <Form.Label htmlFor="complement">Complemento</Form.Label>
                                    <Form.Control
                                        type="text"
                                        id="complement"
                                        name="complement"
                                        defaultValue={form?.complement}
                                        onChange={(e) => handleChange(e, component, 'addressForm')}
                                        aria-describedby="complementHelpBlock"
                                        disabled={disableAddressInput}
                                    />
                                    <Form.Text id="complementHelpBlock" muted>
                                        Informe o complemento
                                    </Form.Text>
                                </div>
                            </Col>
                            <Col lg={4}>
                                <div className="form mt-2">
                                    <Form.Label htmlFor="district">Bairro</Form.Label>
                                    <Form.Control
                                        type="text"
                                        id="district"
                                        name="district"
                                        defaultValue={form?.district}
                                        onChange={(e) => handleChange(e, component, 'addressForm')}
                                        aria-describedby="districtHelpBlock"
                                        disabled={disableAddressInput}
                                    />
                                    <Form.Text id="districtHelpBlock" muted>
                                        Informe o bairro
                                    </Form.Text>
                                </div>
                            </Col>
                            <Col lg={3}>
                                <div className="form mt-2">
                                    <Form.Label htmlFor="city">Cidade</Form.Label>
                                    <Form.Control
                                        type="text"
                                        id="city"
                                        name="city"
                                        defaultValue={form?.city}
                                        onChange={(e) => handleChange(e, component, 'addressForm')}
                                        aria-describedby="cityHelpBlock"
                                        disabled={disableAddressInput}
                                    />
                                    <Form.Text id="cityHelpBlock" muted>
                                        Informe o cidade
                                    </Form.Text>
                                </div>
                            </Col>
                            <Col lg={2}>
                                <div className="form mt-2">
                                    <Form.Label htmlFor="state">UF</Form.Label>
                                    <Form.Control
                                        type="text"
                                        id="state"
                                        name="state"
                                        defaultValue={form?.state}
                                        onChange={(e) => handleChange(e, component, 'addressForm')}
                                        aria-describedby="stateHelpBlock"
                                        disabled={disableAddressInput}
                                    />
                                    <Form.Text id="stateHelpBlock" muted>
                                        Informe o estado
                                    </Form.Text>
                                </div>
                            </Col>
                            <Col lg={3}>
                                <div className="form mt-2">
                                    <Form.Label htmlFor="country">País</Form.Label>
                                    <Form.Control
                                        type="text"
                                        id="country"
                                        name="country"
                                        defaultValue={form?.country}
                                        onChange={(e) => handleChange(e, component, 'addressForm')}
                                        aria-describedby="countryHelpBlock"
                                        disabled={disableAddressInput}
                                    />
                                    <Form.Text id="countryHelpBlock" muted>
                                        Informe o país
                                    </Form.Text>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                )}
            </>
        );
    };
}

export default AddressTabResponsibleForm;